/*import IOError = createjs.IOError;
import ByteArray = createjs.ByteArray;
import Endian = createjs.Endian;*/

export class ZipUtil {
    // TODO: @HTML
    // Is this really necessary?
    public static tryUnzip(bytes: any): any {
        // TODO: @HTML
        // Is this really necessary?

        /*let result: ByteArray;

        try {
            result = ZipUtil.unzip(bytes);
        }
        catch (e: IOError) {
            // IO Error wenn XML versucht wird zu entzippen
            result = null;
        }*/

        return {};
    }

    public static unzip(bytes: any): any {
        //			throw new Error("bla");
        // variables for reading fixed portion of file header
        /* let uncompressedBytes: ByteArray = new ByteArray();
         let flNameLength: number;
         let xfldLength: number;
         let offset: number;
         let compSize: number;
 
         let tempBytes: ByteArray = new ByteArray();
         tempBytes.endian = Endian.LITTLE_ENDIAN;
 
         bytes.position = 0;
         bytes.readBytes(tempBytes, 0, 30);
 
         offset = 0; // stores length of variable portion of metadata
         tempBytes.position = 26; // offset to file name length
         flNameLength = tempBytes.readUnsignedShort(); // store file name
         offset += flNameLength; // add length of file name
         tempBytes.position = 28; // offset to extra field length
         xfldLength = tempBytes.readUnsignedShort();
         offset += xfldLength; // add length of extra field
 
         // read variable length bytes between fixed-length header and compressed file data
         bytes.readBytes(tempBytes, 30, offset);
 
         tempBytes.position = 18;
         compSize = tempBytes.readUnsignedInt(); // store size of compressed portion
 
         // read compressed file to offset 0 of bytes; for uncompressed files
         // the compressed and uncompressed size is the same
         uncompressedBytes = new ByteArray();
         bytes.readBytes(uncompressedBytes, 0, compSize);
 
         uncompressedBytes.inflate();*/
        return {};
    }
}
